import { tenantPrivacySettingsDTOSchema, } from '@instanexus/contracts';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const settingsSchema = dataEnvelopeSchema(tenantPrivacySettingsDTOSchema);
const SETTINGS_PATH = `${WEB_API_PREFIX}/tenant/privacy-settings`;
export function createPrivacySettingsResource(transport) {
    return {
        async get() {
            const envelope = await transport.request({ path: SETTINGS_PATH, schema: settingsSchema });
            return envelope.data;
        },
        async update(input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: SETTINGS_PATH,
                schema: settingsSchema,
                body: input,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=privacy-settings.js.map